import { render } from "./DggramPage.vue?vue&type=template&id=35a35b95&scoped=true"
import script from "./DggramPage.vue?vue&type=script&lang=js"
export * from "./DggramPage.vue?vue&type=script&lang=js"

import "./DggramPage.vue?vue&type=style&index=0&id=35a35b95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a35b95"]])

export default __exports__